import { OptionEntity } from './interfaces/OptionEntity';

export const CATEGORIES: OptionEntity[] = [
	{ title: 'Practice', value: 'practice' },
	{ title: 'Theory', value: 'theory' },
];

export const OCCUPATIONS: OptionEntity[] = [
	{ title: 'All', value: 'all' },
	{ title: 'Frontend', value: 'frontend' },
	{ title: 'Interviews', value: 'interview' },
];

export const getTranslatedOccupations = (t: any) =>
	OCCUPATIONS.map((item) => ({
		...item,
		title: t(item.value),
	}));

export const MONACO_EDITOR_FONT_SIZE = '14px';

export enum CURRENCIES {
	USD = '$',
}

export enum PRODUCT_FORM_TYPES {
	INTERVIEW = 'interview',
	CONSULTATION = 'consultation',
	EXERCISE_REVIEW = 'exercise',
}

export enum LegalDocs {
	COOKIES_MESSAGE = 'cookies_message',
	COOKIES_POLICY = 'cookies_policy',
	PRIVACY_POLICY = 'privacy_policy',
	TERMS_AND_CONDITIONS = 'terms_and_conditions',
}
